module.exports = __webpack_public_path__ + "img/white-bg-cs-logo.6443b037.png";